import { globalReduxStore } from '../../src/modules/initStore'
import { getCoordinates } from '../../src/redux/reducers'
import { processLocation } from '../../src/utils/location'
import { IDB_locationsReadAll } from '../IDB/IDB.table.location'
import type { Type_ILocation, Type_IProcessedLocation } from '../Type/Type.hive'
import { Util_compareObjDistances } from '../Util/Util.distance'

export async function Loca_getLocationsByDistance() {
    const { lat, lon } = getCoordinates(globalReduxStore.getState())

    const results = await IDB_locationsReadAll().catch<Type_ILocation[]>(() => [])

    const locations: Type_IProcessedLocation[] = results.map(processLocation(lat, lon))

    if (lat && lon) {
        locations.sort(Util_compareObjDistances)
    }

    return locations
}
